import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';

import { AuthProvider } from './contexts/AuthContext';
import Navigation from './Components/Navigation';
import PrivateRoute from './Components/PrivateRoute';
import Login from './Pages/Login';
import Signup from './Pages/Signup';
import Admin from './Pages/Admin';
import Stocks from './Pages/Stocks';
import Markets from './Pages/Markets';
import MarketDetail from './Pages/MarketDetail';
import Home from './Pages/Home';
import Apps from './Pages/Apps';
import Links from './Pages/Links';
import Privacy from './Pages/Privacy';
import Wiki from './Pages/Wiki';
import Trump from './Pages/Trump';
import Blog from './Pages/Blog';
import News from './Pages/News';
import Recipes from './Pages/Recipes';
import Specials from './Pages/Specials';
import BlogPost from './Pages/BlogPost';
import AdminBlog from './Pages/AdminBlog';
import Error from './Components/Error';


function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apps" element={<Apps />} />
            <Route path="/links" element={<Links />} />
            <Route path="/specials" element={<Specials />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/news" element={<News />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/admin" element={<PrivateRoute element={<Admin />} adminOnly />} />
            <Route path="/admin/blog" element={<PrivateRoute element={<AdminBlog />} adminOnly />} />
            <Route path="/stocks" element={<PrivateRoute element={<Stocks />} />} />
            <Route path="/recipes" element={<PrivateRoute element={<Recipes />} />} />
            <Route path="/markets" element={<PrivateRoute element={<Markets />} />} />
            <Route path="/markets/:indexKey" element={<PrivateRoute element={<MarketDetail />} />} />
            <Route path="/privacy/:appName" element={<Privacy />} />
            <Route path="/wiki/:appName" element={<Wiki />} />
            <Route path="/trump" element={<Trump />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
